import { EPaymentPeriod, EPriceType } from '../../../repositories/monolith-python/entities/offer/BargainTermsSchema';
import { IOfferBuilding } from './building';
import { IOfferFlags } from './flags';
import { IOfferGeo } from './geo';
import { IOfferHomeowner } from './homeowner';
import { TOfferVideos } from './videos';

export interface IOfferState {
  status: EOfferStatus;
  dealType?: string;
  offerType?: string;
  category: string;
  categoryName?: string;
  bargainTerms: IOfferBargainTerms;
  isByHomeowner: boolean;
  isByCommercialOwner?: boolean;
  areaParts?: IAreaPart[] | null;
  layoutPhoto: ILayoutPhoto | null;
  photos: Array<string>;
  selfEmployedData?: IOfferSelfEmployedData;
  id: number | null;
  geo?: IOfferGeo;
  coworkingOfferType?: string;
  workplaceCount?: number;
  coworking?: ICoworking;
  allRoomsArea?: string;
  businessShoppingCenter?: IBusinessCenter;
  calltrackingPhone?: string;
  phones?: Array<IPhoneNumber | null>;
  terms?: Array<IOfferPublishTerms>;
  videos: TOfferVideos;
  isFromXml: boolean;
  isArchived: boolean;
  building: IOfferBuilding;
  isRentByParts: boolean | null;
  rentByPartsDescription: string | null;
  objectGuid: string;
  calltrackingPhoneIndex: number | null;
  homeOwner: IOfferHomeowner | null;
  publishTerms: IOfferPublishTerms;
  flags?: IOfferFlags;
  isEnabledCallTracking?: boolean | null;
  multiposting: IMultiposting;
  communication?: ICommunication;
  readyBusinessType?: EReadyBusinessType;
  isNeedExactAddress?: boolean;
  dealRentData?: IDealRentData | null;
  totalArea?: number | null;
}

export interface IDealRentData {
  applyDealRentVersion: string | null;
  applyDealRentSource: string | null;
}

export interface ILayoutPhoto {
  id: number;
}

export interface IAreaPart {
  price?: number;
  area?: number;
}

export interface ICoworkingWorkType {
  timeFrom?: string;
  timeTo?: string;
}

export type TCoworkingAmenity = string;

export type TCoworkingWorkplace = {
  cardUrl?: string;
  addformUrl?: string;
};

export interface ICoworking {
  name?: string;
  accessType?: 'weekdays' | 'daily';
  isRoundTheClock?: boolean;
  workTime?: ICoworkingWorkType;
  amenities?: TCoworkingAmenity[];
  flexibleWorkplace: TCoworkingWorkplace | null;
  fixedWorkplace: TCoworkingWorkplace | null;
}

interface IUtilitiesTerms {
  includedInPrice?: boolean;
  flowMetersNotIncludedInPrice?: boolean | null;
}

export enum ECurrency {
  /** € **/
  Eur = 'eur',
  /** ₽ **/
  Rur = 'rur',
  /** $ **/
  Usd = 'usd',
}

interface IOfferBargainTerms {
  price?: number;
  priceForWorkplace?: number;
  utilitiesTerms?: IUtilitiesTerms;
  clientFee: number | null;
  agentFee: number | null;
  deposit: number | null;
  agentBonus: IOfferAgentBonus | null;
  leaseTermType?: string;
  currency?: ECurrency;
  priceType?: EPriceType | null;
  paymentPeriod?: EPaymentPeriod | null;
}

interface IOfferSelfEmployedData {
  isEnabled: boolean;
  inn: string | null;
}

export interface IBusinessCenter {
  /** id бизнес центра */
  id: number;
}

export interface IPhoneNumber {
  countryCode: string;
  number: string;
}

interface IOfferPublishTerms {
  autoprolong: boolean;
  terms: Array<IOfferPublishTerm>;
}

interface IOfferPublishTerm {
  days: number;
  dynamicPrice?: number;
  recommendedServicePackageId?: string;
  services: Array<string>;
  // TODO: дополнить описание
  tariffIdentificator: object;
  type: string;
}

interface ICommunication {
  preferredCommunicationType?: EPreferredCommunicationType;
}

export interface IOfferAgentBonus {
  paymentType: EPaymentType;
  value: number | null;
}

export enum EOfferStatus {
  draft = 'draft',
  published = 'published',
}

export enum EPaymentType {
  /** Фиксированный **/
  Fixed = 'fixed',
  /** Процент от сделки **/
  Percent = 'percent',
}

export enum EPreferredCommunicationType {
  Phone = 'phone',
  Forms = 'forms',
}

export interface IMultiposting {
  enabled: boolean;
}

export enum EReadyBusinessType {
  /** Арендный бизнес */
  RentalBusiness = 'rentalBusiness',
  /** Другое */
  Other = 'other',
}
